<template>
    <div class="totalizers-ports" v-if="currentComponent">
        <component
            :is="currentComponent"
            ref="TotalizersPortsComponent"
            :filters="filters"
            :portId="portId"
        />
    </div>
</template>

<script>
export default {
    name: 'PortsTotalizers',
    props: {
        filters: {
            type: Object,
            required: false,
            default: () => null
        },
        portId: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            components: {
                PY: () =>
                    import(
                        '@/modules/warehouse/views/components/totalizers-ports/py.vue'
                    )
            }
        };
    },
    mounted() {
    },
    computed: {
        currentComponent() {
            this.$emit('input', []);
            const user = this.$store.state.usuarioLogado;
            return this.components[user.paisGrupo];
        }
    },
    watch: {
    },
    methods: {
        getTotalizers() {
            this.$refs.TotalizersPortsComponent.loadTotalizers();
        }
    }
};
</script>

<style scoped lang="scss">
h3 {
    margin: 16px 0;
    color: #3b3b3b;
    font-weight: 500;
    font-size: 16px;
}

.totalizers-ports {
    // margin-top: 16px;
}
</style>
